<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OMd1o0/tc-custom/9781035849666.jpg?1726483235710" alt="This image is the cover for the book The Morning Star"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Morning Star
      </h1>
      <p class="bookDescription body article font2">
        <p>In this sixth collection, Terry Wilson writes about a fish that became an elephant and how this is better than becoming a human. We all want to be elephants someday. This is poetry about the holes in life rather than the whole of life, and what we see through them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terry Wilson
      </h2>
      
      <p class="authorDescription body article">Terry Wilson is the author of Fifty, Natural, Fox Spirit, The Lane and Other Poems, and At The Blue Door. He lives in Adelaide, South Australia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f147c494